import React, { useState, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Filter from '../../Filter';
import Table from '../../Table';
import Pagination from '../../TablePagination';
import LimitButton from '../../LimitSelectBox';
import BookingCreate from './BookingCreate';
import ExcelUpload from './ExcelUpload';
import ExcelDownload from './ExcelDownload';
import BookingUpdate from './BookingUpdate';
import KeyIssue from '../userkeys/UserkeyIssue';
import BookingCancel from './BookingCancel';
import { dateFormatter } from '../../../lib/formatter';

const BookingListTable = ({
  bookingListTotal,
  bookingListItems,
  buildingListItems,
  filterItem,
  sortItem,
  paginationItem,
  currentPageNumber,
  viewType,
  listBookingApi,
  setFilterItem,
  setSortItem,
  setPaginationItem,
  setCurrentPageNumber,
  changeViewType,
  history,
}) => {
  const { t } = useTranslation();
  const [ isOpenBookingCreateModal, setIsOpenBookingCreateModal ] = useState(false);
  const [ isOpenExcelUploadModal, setIsOpenExcelUploadModal ] = useState(false);
  const [ isOpenExcelDownloadModal, setIsOpenExcelDownloadModal ] = useState(false);
  const [ isOpenBookingUpdateModal, setIsOpenBookingUpdateModal ] = useState(false);
  const [ isOpenKeyIssueModal, setIsOpenKeyIssueModal ] = useState(false);
  const [ isOpenBookingCancelModal, setIsOpenBookingCancelModal ] = useState(false);
  const [ selectedBookingId, setSelectedBookingId ] = useState('');
  const [ selectedRoomName, setSelectedRoomName ] = useState('');

  const changePagination = (pageNumber) => {
    setCurrentPageNumber(pageNumber);
    setPaginationItem({
      ...paginationItem,
      offset: (pageNumber - 1) * paginationItem.limit,
    });
  };

  const changeLimit = (limit) => {
    setCurrentPageNumber(1);
    setPaginationItem({
      offset: 0,
      limit,
    });
  };

  const changeSort = (sort) => {
    if (sortItem.sort === sort) {
      setSortItem({
        ...sortItem,
        order: sortItem.order === 'desc' ? 'asc':'desc',
      });
    } else {
      setSortItem({
        sort,
        order: 'desc',
      });
    }
  };

  //디바운싱 사용 구분을 위해 debounce props 추가
  const changeFilterItem = (targetItem, debounce) => {
    setFilterItem({
      ...filterItem,
      ...targetItem,
    }, debounce);
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const initFilterItem = () => {
    setFilterItem({
      buildingId: '',
      roomName: '',
      phoneNumber: '',
      startAt: '',
      endAt: '',
    });
    setCurrentPageNumber(1);
    setPaginationItem({
      ...paginationItem,
      offset: 0,
    });
  };

  const selectBookingUpdate = (bookingId) => {
    setSelectedBookingId(bookingId);
    setIsOpenBookingUpdateModal(true);
  };

  const selectKeyIssue = (bookingId, roomName) => {
    setSelectedBookingId(bookingId);
    setSelectedRoomName(roomName);
    setIsOpenKeyIssueModal(true);
  };

  const selectBookingCancel = (bookingId) => {
    setSelectedBookingId(bookingId);
    setIsOpenBookingCancelModal(true);
  };

  return (
    <Fragment>
      <div className='content-title2'>
        <h3>{t('content_title.booking_list')}</h3>
        <div className='view-type-wrap'>
          {/* <button className={`view-type ${viewType === 'table' ? 'selected':''}`} onClick={() => changeViewType('table')}>
            <FontAwesomeIcon icon={faList}/>
          </button>
          <button className={`view-type ${viewType === 'card' ? 'selected':''}`} onClick={() => changeViewType('card')}>
            <FontAwesomeIcon icon={faTable}/>
          </button> */}
        </div>
      </div>
      <div className='content-title'>
        <div className='excel-upload' onClick={() => setIsOpenExcelUploadModal(true)}>
          <img className='excel-logo' src='../assets/images/excel.png' alt='excel_logo'></img>
          <span>{t('button.booking_excel_upload')}</span>
        </div>
        <div className='excel-upload ml-10' onClick={() => setIsOpenExcelDownloadModal(true)}>
          <img className='excel-logo' src='../assets/images/excel.png' alt='excel_logo'></img>
          <span>{t('button.booking_excel_download')}</span>
        </div>
        <Filter
          columns={[
            {
              key: 'startAt',
              type: 'datePicker',
              placeholder: t('data_column.checkin_at'),
              value: filterItem.startAt,
              action: changeFilterItem,
              selectsStart: true,
              maxDate: filterItem.endAt,
              endDate: filterItem.endAt,
              showTimeSelect: true,
              isRemoveButton: true,
            },
            {
              key: 'endAt',
              type: 'datePicker',
              placeholder: t('data_column.checkout_at'),
              value: filterItem.endAt,
              action: changeFilterItem,
              selectsEnd: true,
              minDate: filterItem.startAt || moment().startOf('day').toDate(),
              startDate: filterItem.startAt,
              showTimeSelect: true,
              isRemoveButton: true,
            },
            {
              key: 'buildingId',
              type: 'select',
              size: 'xlg',
              placeholder: t('data_column.building'),
              value: filterItem.buildingId,
              action: changeFilterItem,
              selectItems: buildingListItems,
              selectItemKey: 'name',
              selectItemValue: 'id',
              isRemoveButton: true,
            },
            {
              key: 'roomName',
              size: 'lg',
              placeholder: t('data_column.room'),
              value: filterItem.roomName,
              action: changeFilterItem,
            },
            {
              key: 'phoneNumber',
              size: 'lg',
              placeholder: t('data_column.phone_number'),
              value: filterItem.phoneNumber,
              action: changeFilterItem,
            },
          ]}
          init={initFilterItem}
        />
      </div>
      <Table
        columns={[
          {
            key: 'view',
            text: t('data_column.view'),
            width: '8%',
            moveToPage: {
              func: (bookingId) => history.push(`/booking/${bookingId}`),
              params: ['id'],
            },
          },
          {
            key: 'user.name',
            // key: 'user_name',
            text: t('data_column.user_name'),
            width: '14%',
            formatter: {
              func: (name, phoneNumber) => `${name}(${phoneNumber})`,
              params: ['user.name', 'user.phone_number'],
              // func: (userName) => userName,
              // params: ['user_name'],
            },
          },
          {
            key: 'checkin_at',
            text: t('data_column.checkin_at'),
            width: '12%',
            formatter: {
              func: dateFormatter,
              // func: (checkinAt) => checkinAt,
              params: ['checkin_at'],
            },
          },
          {
            key: 'checkout_at',
            text: t('data_column.checkout_at'),
            width: '12%',
            formatter: {
              func: dateFormatter,
              // func: (checkoutAt) => checkoutAt,
              params: ['checkout_at'],
            },
          },
          {
            key: 'building.name',
            text: t('data_column.building'),
            width: '11%',
            linker: {
              func: (buildingId) => history.push(`/building/${buildingId}`),
              params: ['building.id'],
            },
          },
          {
            key: 'room.name',
            // key: 'room_name',
            text: t('data_column.room'),
            width: '10%',
            linker: {
              func: (buildingId, roomId) => history.push(`/room/${roomId}`, {buildingId}),
              params: ['building.id', 'room.id'],
              // func: (roomName) => roomName,
              // params: ['room_name'],
            },
            sort: {
              func: changeSort,
              params: 'room_name',
              selected: sortItem.sort === 'room_name',
              order: sortItem.sort === 'room_name' ? sortItem.order : 'desc',
            },
          },
          {
            key: 'cards',
            text: t('data_column.cardkey_count'),
            width: '7%',
            formatter: {
              func: (cards) => cards.length,
              params: ['cards'],
            },
          },
          {
            key: 'mobilekeys',
            text: t('data_column.mobilekey_count'),
            width: '7%',
            formatter: {
              func: (mobilekeys) => mobilekeys.length,
              params: ['mobilekeys'],
            },
          },
          {
            key: 'pincodes',
            text: t('data_column.pincode_count'),
            width: '7%',
            formatter: {
              func: (pincodes) => pincodes.length,
              params: ['pincodes'],
            },
          },
          {
            key: 'created_at',
            text: t('data_column.created_at'),
            width: '12%',
            formatter: {
              func: dateFormatter,
              params: ['created_at'],
            },
          },
          {
            key: 'button',
            text: '',
            width: '5%',
            items: [
              {
                text: t('button.edit'),
                action: {
                  func: selectBookingUpdate,
                  params: ['id'],
                },
              },
              {
                text: t('button.key_issue'),
                action: {
                  func: selectKeyIssue,
                  params: ['id', 'room.name'],
                },
              },
              {
                text: t('button.delete'),
                action: {
                  func: selectBookingCancel,
                  params: ['id'],
                },
              },
            ],
          },
        ]}
        datas={bookingListItems}
      />
      <LimitButton
        currentLimit={paginationItem.limit}
        changeLimit={changeLimit}
      />
      <div className='form-item-add'>
        <button className='btn-item-add list' onClick={() => setIsOpenBookingCreateModal(true)}>
          <FontAwesomeIcon icon={faPlusCircle} className='icon-item-add'/>
          <span>{t('button.booking_add')}</span>
        </button>
      </div>
      <Pagination
        total={bookingListTotal}
        index={currentPageNumber}
        limit={paginationItem.limit}
        indexChange={changePagination}
      />
      <BookingCreate
        isOpen={isOpenBookingCreateModal}
        toggle={() => setIsOpenBookingCreateModal(!isOpenBookingCreateModal)}
        reload={() => listBookingApi()}
      />
      <ExcelUpload
        isOpen={isOpenExcelUploadModal}
        toggle={() => setIsOpenExcelUploadModal(!isOpenExcelUploadModal)}
        reload={() => listBookingApi()}
      />
      <ExcelDownload
        isOpen={isOpenExcelDownloadModal}
        toggle={() => setIsOpenExcelDownloadModal(!isOpenExcelDownloadModal)}
      />
      <BookingUpdate
        isOpen={isOpenBookingUpdateModal}
        toggle={() => setIsOpenBookingUpdateModal(!isOpenBookingUpdateModal)}
        reload={() => listBookingApi()}
        bookingId={selectedBookingId}
      />
      <KeyIssue
        isOpen={isOpenKeyIssueModal}
        toggle={() => setIsOpenKeyIssueModal(!isOpenKeyIssueModal)}
        reload={() => listBookingApi()}
        bookingId={selectedBookingId}
        roomName={selectedRoomName}
      />
      <BookingCancel
        isOpen={isOpenBookingCancelModal}
        toggle={() => setIsOpenBookingCancelModal(!isOpenBookingCancelModal)}
        reload={() => listBookingApi()}
        bookingId={selectedBookingId}
      />
    </Fragment>
  );
};

export default BookingListTable;